import React from 'react';
import * as C from '../common-styles.styles';
import * as S from './list-for-links.styles';

const Link = props => {
  const { link } = props;
  if (link.lowestFare) {
    return (
      <S.LinkWithLowestFare className="flexCol alignItemsStart">
        <a href={`https://${link.url}`} className="flexCol alignItemsStart">
          {link.name}
          <span>{link.lowestFare}</span>
        </a>
      </S.LinkWithLowestFare>
    );
  }

  return (
    <S.LinkContain>
      <a href={link?.url?.includes('https://') ? link.url : `https://${link.url}`}>
        {link.name || link.text}
      </a>
    </S.LinkContain>
  );
};

const ListForLinks = props => {
  const { title, links, isDweb = false, html = '' } = props;
  if (html) {
    return (
      <C.Wrap isDweb={isDweb}>
        <S.Details>
          <div dangerouslySetInnerHTML={{ __html: html }}></div>
        </S.Details>
      </C.Wrap>
    );
  }
  if (!links || links.length <= 0) {
    return null;
  }
  return (
    <C.Wrap isDweb={isDweb}>
      <S.Details>
        <h3>{title}</h3>
        {links.map((link, index) => (
          <Link link={link} key={index} />
        ))}
      </S.Details>
    </C.Wrap>
  );
};

export default ListForLinks;
